var Backbone = require('backbone'),
    Raphael = require('raphael'),
    Shape = require('./baseShape'),
     _ = require('underscore');

require('raphaelExportSVG');

module.exports = Backbone.Collection.extend({

    model: Shape,

    /* get data */
    getShapesOfNote: function(note) {
        return this.filter(function(s) {
            return s.isChildOfNote(note) ;
        });
    },

    getShapeUIModelsOfNote: function(note) { /* (the child ui models */

        return this.chain()
            .filter(function(s) { return s.isChildOfNote(note); })
            .map( function(s) { return s.uiModel; })
            .value();

    },

    getAllShapeUIModels: function() {
        return this.map(function(s) {
            return s.uiModel;
        });
    },

    // Returns all shapes on canvas other than those of the given note.
    // noteTypeFilter filter is optional.
    getAllShapesButNote: function(note, noteTypeFilter) {

        var shapes = this.filter(function(s) {
            return !s.isChildOfNote(note);
        });

        noteTypeFilter && (shapes = _.filter(shapes, function(s) {
            return s.getParentNote().get('noteType') === noteTypeFilter;
        }));

        return shapes;
    },
    /*
    * Get the SVG of the note -- unadjusted for scaling and rotation ('denormalized').
    * ( the active note, adjusted for current scale )
    * TODO: branch from single fn, put on view / model, out of model ...
    * TODO: s/b able to get the full page model from the note
    * */
    _getNoteShapesSVG: function(note, scale, pageModel) {

        var shapes = this.getShapesOfNote(note);
        if (shapes.length < 1)
            return '';

        // get Raphael from paper to feed plugin (Raphael.fn.toSVG)
        // don't want to feed the entire paper (eg this.shapes (not just this note), subshapes) -- could have a filter in the fork instead

        var shapeSet = [], // shapes[0].uiModel.getRaphaelElPaper().set(), no longer a set ... can take a group ... or Raphael el
            pg = pageModel,
            pgIsCold = pg.isCold(),
            rotation = pg.get('rotation') % 360,

            origDimsWithScaleApplied = pgIsCold ? null : pg.originalDimensions(scale),
            //center pt of the original dimensions scaled and rotated
            originalCenterPtWithScaleAndRotationApplied = pgIsCold ? null : pg.getOriginalCenterPtRotated(scale);


        /* plugin wants to export an entire paper obj -- changed for set ... */
        _.each( shapes, function(s) {

            var normalizedShapeEl =
                s.getNormalizedElToPerist(scale, rotation, origDimsWithScaleApplied, originalCenterPtWithScaleAndRotationApplied);

            //note: can return multi (eg for signature array of 2 rEls )

            if ( !(normalizedShapeEl instanceof Array) ) {

                shapeSet.push(normalizedShapeEl);

            } else {

                _.each( normalizedShapeEl, function(s) {
                    shapeSet.push(s);
                });
            }

        });

        /*
        *  Maybe want to just call off the paper, not Raphael fn
        * ... perhaps issue with clones has something to do with this ...
        * ... and then no need to remove ... ???
        * DVBC-1592 - provide the original, non rotated dimensions of the paper.
        * DVBC-1594 - hack: temp transform until refactor w, h to be width, height.
        * */
        var originalPgDimensions = pg.originalDimensions();

        var pageDimensions = pgIsCold
            ?  { width: '100%',  height: '100%' } // previously in plugin was deriving from paper.width, paper.height, which was 100%
            :  { width: originalPgDimensions.w + 'px', height: originalPgDimensions.h + 'px' };

        var svg = Raphael.fn.toSVG( shapeSet, pageDimensions );

        // Uncomment for debug without escaped markup ( it is escaped however in the plugin )
        //console.log( svg );

        // now remove the clones (they are put on the paper) ... TODO: don't need to have clone ...

        shapeSet.forEach( function(s) {
            s.remove && s.remove();
        } );

        shapeSet = null;

        return svg;

    },

    /*
    * Export for save.
    * TODO: an override for each type
    * */
    getShapeAttributesOfNote: function(note) {

        var shapeAttrsToPersist = this._getNoteShapesAttrsToPersist.apply(this, arguments);

        if ( note.isSVGGraphicNote() || note.isSignature() || note.isTextStamp() ) { // TODO: better XREF, eg : 'SVG'
            
            return {text: shapeAttrsToPersist};

        } else if ( note.isGraphicStamp() ) {

            // pageNote properties already on the object: x, y, width, height (there's only ever one shape)
            return shapeAttrsToPersist;

        } else {
            
            // the original coordinate shapes
            return {shapes: shapeAttrsToPersist };
        }

    },
    /*
    * These should be on the note -- but on the canvas: the shapes on the canvas of the note
    * */
    _getNoteShapesAttrsToPersist: function(note, scale, page) {

        if ( note.isTextStamp() ) {

            var shapeOfNotes = this.getShapesOfNote(note);
            /**
             * Prevent error here in current WF is stamp is not placed when cancel changes ( if user changed to stamp that wasn't ready ) -- cancel modify
             * Better answer is not allow WF to get to this point unless a stamp has been placed
             * ( Though this is good to prevent errors anyway )
             */
            if ( shapeOfNotes.length < 1 )
                return '';

            /* There can only be one */
            return shapeOfNotes[0].getNormalizedElToPerist();

        }
        else if ( note.isSVGGraphicNote() || note.isSignature() ) { //TODO: a better XREF, eg : 'SVG'

            return this._getNoteShapesSVG.apply(this, arguments);

        }  else if ( note.isGraphicStamp() ) {

            // only one shape can exist for this note type
            var shapesOfNote = this.getShapesOfNote(note);

            // return empty array to handle case where the note is new and no shape has been created
            // this will then fail the 'no shapes' validation in the save note workflow
            if ( shapesOfNote.length < 1 )
                return [];

            return shapesOfNote[0].getAttrsToPersist(scale);
        }

        else {
            /*
            * The 'original' coordinate notes.
            * Here called at the shape level.
            * */
            return _.map( this.getShapesOfNote(note) , function(s) {
                return s.getAttrsToPersist(scale);
            });
        }

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/models/shapes.js
 ** module id = 387
 ** module chunks = 0
 **/